import home from '@/pages/views/home/home.vue'
import overview from '@/pages/views/overview/overview.vue';
import news from '@/pages/views/news/news.vue';
import newsInfo from '@/pages/views/news/newsInfo.vue';
import doctorSpace from '@/pages/views/knowledge/doctorSpace.vue'; // 博士讲堂
import opinion from '@/pages/views/knowledge/opinion.vue'; // 专家解析
import authoritative from '@/pages/views/knowledge/authoritative.vue'; // 权威观点
import knowInfo from '@/pages/views/knowledge/knowInfo.vue';
import product from '@/pages/views/product/product.vue';
import productInfo from '@/pages/views/product/productInfo.vue';
import activity from '@/pages/views/activity/activity.vue';
import activityInfo from '@/pages/views/activity/activityInfo.vue';
import members from '@/pages/views/members/members.vue';
import memeberInfo from '@/pages/views/members/memeberInfo.vue';
import results from '@/pages/views/findList/results.vue';
/* eslint-disable */
const frontViews = [{
    path: '/home',
    name: 'home',
    component: home
  },
  {
    path: '/overview',
    name: 'overview',
    component: overview
  },
  {
    path: '/news',
    name: 'news',
    component: news
  }, {
    path: '/doctorSpace',
    name: 'doctorSpace',
    component: doctorSpace
  }, {
    path: '/opinion',
    name: 'opinion',
    component: opinion
  }, {
    path: '/authoritative',
    name: 'authoritative',
    component: authoritative
  }, {
    path: '/knowInfo/:knowledgeId',
    name: 'knowInfo',
    component: knowInfo
  },
  {
    path: '/product',
    name: 'product',
    component: product
  },
  {
    path: '/productInfo/:productId',
    name: 'productInfo',
    component: productInfo
  }, {
    path: '/activity',
    name: 'activity',
    component: activity
  },
  {
    path: '/activityInfo/:infoId',
    name: 'activityInfo',
    component: activityInfo
  }, {
    path: '/members',
    name: 'members',
    component: members
  }, {
    path: '/memeberInfo/:mid',
    name: 'memeberInfo',
    component: memeberInfo
  }, {
    path: '/newsInfo/:newsId',
    name: 'newsInfo',
    component: newsInfo
  },
  {
    path: '/results',
    name: 'results',
    component: results
  }
];
export default [...frontViews]



// WEBPACK FOOTER //
// ./src/router/views.js